import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg"
          role="alert"
        >
          <h1 className="text-xl font-bold mb-2">Something went wrong.</h1>
          <p>
            We're sorry for the inconvenience. Please try refreshing the page or
            contacting support if the problem persists.
          </p>
          {process.env.NODE_ENV === "development" && (
            <details className="mt-4 whitespace-pre-wrap bg-red-50 p-2 rounded">
              <summary className="font-semibold cursor-pointer">
                Error Details
              </summary>
              <p className="mt-2 text-sm">
                {this.state.error && this.state.error.toString()}
              </p>
              <p className="mt-2 text-sm font-mono">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </p>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
